import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import FileUpdateButton from '../FileUpdateButton'
import Button from '../../../../../common/Button'
import { getViewDownloadLinkForProcoDocs } from '../../../../../../lib/fetchApi'
import { documentHasFileId } from '../../../../../../lib/docs'
import HistoryModal from './HistoryModal'

import classes from './Status.module.css'

export default function DocumentUploaded({practiceId, usedFor, documentItem, uploadDisabled, isGeneral, right, activeCase, uploadPermission, updatePermission}) {

    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const userToken = useSelector(state => state.user.token)
    const canReupload = updatePermission || (practiceId === 'all' && uploadPermission)

    async function viewDocumentHandler() {
        setLoading(true)
        let doc = await getViewDownloadLinkForProcoDocs(userToken, activeCase.case.id, 'procodocs', documentItem.id, dispatch)

        if (doc && doc.view_url) {
            var win = window.open(doc?.view_url, '_blank');
            win.focus();
        }

        setLoading(false)
    }

    return <div className={classes.document_item_wrapper}>

        {documentItem && documentItem.history && documentItem.history.length > 0 && <HistoryModal history={documentItem.history} uploadedDocument={documentItem} modalRight={right}>
            <div className={`${classes.document_uploaded} ${classes.document_item}`}>
                <div className={classes.icon}>
                    {documentHasFileId(documentItem) && <Button title='view document' btnStyle={'btn_simple'} click={viewDocumentHandler} isLoading={loading} loaderType={'dark'}><i className="ti ti-file-check"></i></Button>}
                </div>
                {!uploadDisabled && canReupload && <FileUpdateButton practiceId={practiceId} usedFor={usedFor} existingDocument={documentItem} isGeneral={isGeneral}/>}
            </div>    
        </HistoryModal>}

        {documentItem && (!documentItem.history || documentItem.history.length == 0) && <div className={`${classes.document_uploaded} ${classes.document_item}`}>
            <div className={classes.icon}>
                {documentHasFileId(documentItem) && <Button title='view document' btnStyle={'btn_simple'} click={viewDocumentHandler} isLoading={loading} loaderType={'dark'}><i className="ti ti-file-check"></i></Button>}
            </div>
            {!uploadDisabled && canReupload && <FileUpdateButton practiceId={practiceId} usedFor={usedFor} existingDocument={documentItem} isGeneral={isGeneral}/>}
        </div>}
    </div>
}